module.exports = __webpack_public_path__ + "static/media/icon_writing.5c051f5a.png";